// extracted by mini-css-extract-plugin
module.exports = {"profile":"Profile-module--profile--6pPfr","handle":"Profile-module--handle--MOmeU","title":"Profile-module--title--3x7Bh"};